import React, { Component } from 'react';

const length = 8;

export default class Row extends Component {
  constructor(props) {
    super(props);
    this.state = { values : Array.from({ length }, (_, i) => {
      return !!i && props.value;
    }) };
    this.handler = this.handler.bind(this);
  }

  handler(e) {
    const on = e.target.checked;
    const bit = parseInt(e.target.value, 10);
    let value = this.props.value;
    if (on) {
      value = value + bit;
    } else {
      value = value - bit;
    }

    this.props.set(value);
  }

  render() {
    return <div className="Row">{
      Array.from({ length }, (v, i) => {
        const bit = 2 ** (7 - i);
        return (
          <input
            onChange={this.handler}
            key={`bit-${bit}`}
            type="checkbox"
            value={ bit }
            checked={ !!(this.props.value & bit) }
            className="bit"
          />
        );
      })
    }</div>;
  }
}



// WEBPACK FOOTER //
// ./src/Row.js